import { state } from './state';

/**
 * Sentry telemetry must never bubble up: on a 24/7 kiosk a broken SDK call
 * should not kill the flow that was trying to log. These wrappers run the
 * call inside a try/catch, bail if the SDK isn't initialized yet, and log
 * failures through `console.warn`.
 *
 * Use `safe(label, fn)` inside the module for any Sentry SDK call that might
 * throw. Use `safeSilent(fn)` when a failure should be swallowed without any
 * log line (e.g. best-effort scope cleanup paths).
 */

export function safe<T>(label: string, fn: () => T): T | undefined {
  if (!state.initialized) return undefined;
  try {
    return fn();
  } catch (e) {
    console.warn(`[Sentry] ${label} failed:`, (e as Error).message);
    return undefined;
  }
}

export function safeSilent<T>(fn: () => T): T | undefined {
  if (!state.initialized) return undefined;
  try {
    return fn();
  } catch {
    return undefined;
  }
}
